import React from 'react';

export default React.createContext({
  goBack: null,
  campaign: null,
});
